import {
    MAP__16,
    CITY__16,
    LOCATION__16,
    PLANE__16,
    TRAIN__16,
    GLOBE__16,
    CAMERA__16,
    BEACH__16,
    SNOWFLAKE__16,
    LANDSCAPE__16
} from '@homeaway/svg-defs';

const resultTypes = [
    {
        typesAssigned: ['locality'],
        label: 'typecity',
        icon: CITY__16
    },
    {
        typesAssigned: ['train_station'],
        label: 'typetrainstation',
        icon: TRAIN__16
    },
    {
        typesAssigned: ['metro_station'],
        label: 'typemetrostation',
        icon: TRAIN__16
    },
    {
        typesAssigned: [
            'continent',
            'country',
            'administrative_division_level_1',
            'administrative_division_level_2',
            'administrative_division_level_3',
            'administrative_division_level_4',
            'administrative_division_level_5',
            'touristic_region',
            'island'
        ],
        label: 'typeregion',
        icon: GLOBE__16
    },
    {
        typesAssigned: [
            'postal_code',
            'neighborhood',
            'sublocality_level_1',
            'sublocality_level_2',
            'sublocality_level_3',
            'sublocality_level_4',
            'sublocality_level_5'
        ],
        label: 'typeneighborhood',
        icon: MAP__16
    },
    {
        typesAssigned: ['beach'],
        label: 'typelandmark',
        icon: BEACH__16
    },
    {
        typesAssigned: ['ski_area'],
        label: 'typelandmark',
        icon: SNOWFLAKE__16
    },
    {
        typesAssigned: [
            'natural_feature',
            'point_of_interest',
            'poi',
            'event',
            'museum'
        ],
        label: 'typelandmark',
        icon: CAMERA__16
    },
    {
        typesAssigned: [
            'premise',
            'premises',
            'establishment',
            'restaurant',
            'transportation'
        ],
        label: 'typelandmark',
        icon: LOCATION__16
    },
    {
        typesAssigned: ['park'],
        label: 'typelandmark',
        icon: LANDSCAPE__16
    },
    {
        typesAssigned: ['airport'],
        label: 'typeairport',
        icon: PLANE__16
    }
];

export function getSuggestionDetails(type, isLIDSearch = false) {
    let details = [];
    if (type) {
        type = type.toLowerCase();

        details = resultTypes.filter((resultData) => {
            return resultData.typesAssigned.indexOf(type) >= 0;
        });
    }
    const defaultLabel = isLIDSearch ? 'typeproperty' : 'typeregion';

    return {
        label: details[0] ? details[0].label : defaultLabel,
        icon: details[0] ? details[0].icon : LOCATION__16
    };
}
